import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, concatMap, map, catchError, of } from "rxjs";
import { ScheduledJobsClient } from "src/api-service";
import { normalizeError } from "../../../../app-store-error.types";
import { AutoArchiveActions } from "./auto-archive.actions";

@Injectable()
export class AutoArchiveEffects {
    private readonly actions$ = inject(Actions);
    private readonly scheduledJobsClient = inject(ScheduledJobsClient);

    loadPreview$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AutoArchiveActions.loadPreview),
            switchMap(({ daysAfterExpiry }) =>
                this.scheduledJobsClient.previewExpiredQuotes(daysAfterExpiry).pipe(
                    map(result => AutoArchiveActions.loadPreviewSuccess({ result })),
                    catchError(error =>
                        of(
                            AutoArchiveActions.loadPreviewFailure({
                                error: normalizeError(error),
                                toastKey: "DEVELOPER.AUTO_ARCHIVE.LOAD_ERROR",
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    execute$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AutoArchiveActions.execute),
            concatMap(({ daysAfterExpiry }) =>
                this.scheduledJobsClient.autoArchiveExpiredQuotes(daysAfterExpiry).pipe(
                    map(result =>
                        AutoArchiveActions.executeSuccess({
                            result,
                            toastKey: "DEVELOPER.AUTO_ARCHIVE.EXECUTE_SUCCESS",
                        }),
                    ),
                    catchError(error =>
                        of(
                            AutoArchiveActions.executeFailure({
                                error: normalizeError(error),
                                toastKey: "DEVELOPER.AUTO_ARCHIVE.EXECUTE_ERROR",
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );
}
